/*
 * <graffiti-color-picker>
 *
 * Wird nur auf dem Produkttemplate 'graffiti' geladen.
 * Siehe docs/umsetzungsplan-graffiti-produkttemplate.md
 *
 * GRUNDREGEL: Diese Komponente waehlt keine Variante aus.
 * Den kompletten Variantenprozess (Preis, Grundpreis, SKU, Verfuegbarkeit,
 * Buy-Buttons, Bild, ?variant=-Sync) macht weiterhin theme.min.js ueber den
 * Klick auf [data-swatch-item]. Diese Komponente
 *   - navigiert per Tastatur und loest dort einen echten Klick aus,
 *   - spiegelt den vom Theme gesetzten Zustand .is--selected nach ARIA,
 *   - scrollt die aktive Farbe in den sichtbaren Bereich.
 * Kein zweites Variantensystem.
 */
(function () {
  'use strict';

  if (customElements.get('graffiti-color-picker')) return;

  var SWATCH = '[data-swatch-item]';

  class GraffitiColorPicker extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-swatch-list]');
      if (!this.grid) return;

      this.swatches = Array.prototype.slice.call(this.grid.querySelectorAll(SWATCH));

      this.onKeydown = this.handleKeydown.bind(this);
      this.grid.addEventListener('keydown', this.onKeydown);

      this.setupControls();
      this.setupStatus();
      this.applyFilter();
      this.updateStatus();

      // Das Theme setzt .is--selected auf den Swatches. Statt den Zustand
      // doppelt zu fuehren, wird jede Klassenaenderung nach ARIA gespiegelt.
      this.observer = new MutationObserver(this.syncSelection.bind(this));
      this.observer.observe(this.grid, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });

      this.scrollSelectedIntoView();
    }

    disconnectedCallback() {
      if (this.grid) this.grid.removeEventListener('keydown', this.onKeydown);
      if (this.observer) this.observer.disconnect();
    }

    setupControls() {
      this.searchInput = this.querySelector('[data-gf-search-input]');
      this.availableOnly = this.querySelector('[data-gf-available-only]');
      this.countEl = this.querySelector('[data-gf-count]');
      this.emptyEl = this.querySelector('[data-gf-empty]');

      var self = this;

      if (this.searchInput) {
        var timer = null;
        this.searchInput.addEventListener('input', function () {
          window.clearTimeout(timer);
          timer = window.setTimeout(self.applyFilter.bind(self), 120);
        });

        // Das Suchfeld sitzt im Produktformular: Enter wuerde sonst das
        // Formular absenden und die Variante in den Warenkorb legen.
        this.searchInput.addEventListener('keydown', function (event) {
          if (event.key === 'Enter') event.preventDefault();
        });
      }

      if (this.availableOnly) {
        this.availableOnly.addEventListener('change', this.applyFilter.bind(this));
      }
    }

    /**
     * Suche und Verfuegbarkeit anwenden.
     * Nicht passende Swatches werden nur ausgeblendet, nie aus dem DOM entfernt —
     * sonst verlieren die Handler von theme.min.js ihr Ziel.
     */
    applyFilter() {
      var query = this.searchInput
        ? this.searchInput.value.trim().toLowerCase()
        : '';
      var onlyAvailable = this.availableOnly ? this.availableOnly.checked : false;

      var visible = 0;

      this.swatches.forEach(function (el) {
        var matches = true;

        if (query && (el.getAttribute('data-gf-search') || '').indexOf(query) === -1) {
          matches = false;
        }
        if (matches && onlyAvailable && el.getAttribute('data-gf-available') !== 'true') {
          matches = false;
        }

        el.hidden = !matches;
        if (matches) visible++;
      });

      this.updateCount(visible);
      this.ensureTabStop();
    }

    /** Trefferzahl als Live-Region, damit Screenreader die Filterwirkung mitbekommen. */
    updateCount(visible) {
      if (this.countEl) {
        var tpl = this.getAttribute('data-count-tpl') || '@@n@@';
        this.countEl.textContent = tpl.replace('@@n@@', visible);
      }
      if (this.emptyEl) this.emptyEl.hidden = visible !== 0;
    }

    /**
     * Nach dem Filtern kann der einzige Tab-Einstiegspunkt ausgeblendet sein.
     * Dann rueckt der erste sichtbare Swatch nach, sonst ist die Gruppe per
     * Tastatur nicht mehr erreichbar.
     */
    ensureTabStop() {
      var items = this.visibleSwatches();
      if (!items.length) return;

      var hasTabStop = items.some(function (el) {
        return el.getAttribute('tabindex') === '0';
      });
      if (hasTabStop) return;

      var selected = items.filter(function (el) {
        return el.classList.contains('is--selected');
      })[0];

      (selected || items[0]).setAttribute('tabindex', '0');
    }

    setupStatus() {
      this.statusEl = this.querySelector('[data-gf-status]');
      this.statusChip = this.querySelector('[data-gf-status-chip]');
      this.statusName = this.querySelector('[data-gf-status-name]');
      this.statusMeta = this.querySelector('[data-gf-status-meta]');
      this.statusAvail = this.querySelector('[data-gf-status-avail]');

      // Den SKU pflegt das Theme bereits im meta-Block und aktualisiert ihn dort
      // beim Variantenwechsel. Er wird gespiegelt statt ein zweites Mal gefuehrt.
      var scope = this.closest('[data-callBackVariant]') || document;
      this.themeSkuEl = scope.querySelector('[data-product__sku-number]');
    }

    /**
     * Statusblock aus dem gewaehlten Swatch befuellen.
     * Quelle ist immer der vom Theme gesetzte Zustand, nie eine eigene Kopie.
     */
    updateStatus() {
      if (!this.statusEl) return;

      var selected = this.grid.querySelector(SWATCH + '.is--selected');

      this.statusEl.classList.toggle('is--empty', !selected);
      if (!selected) {
        if (this.statusChip) this.statusChip.style.removeProperty('--gf-swatch-color');
        if (this.statusMeta) this.statusMeta.textContent = '';
        if (this.statusAvail) this.statusAvail.textContent = '';
        return;
      }

      var hex = selected.getAttribute('data-gf-hex') || '';
      var name = selected.getAttribute('data-value') || '';
      var available = selected.getAttribute('data-gf-available') === 'true';

      if (this.statusName) this.statusName.textContent = name;

      if (this.statusChip) {
        this.statusChip.className =
          'gf-status__chip' +
          (selected.classList.contains('gf-swatch--light') ? ' gf-swatch--light' : '');
        var img = selected.style.getPropertyValue('--gf-swatch-img');
        if (img) {
          this.statusChip.style.setProperty('--gf-swatch-img', img);
          this.statusChip.style.removeProperty('--gf-swatch-color');
        } else {
          this.statusChip.style.setProperty('--gf-swatch-color', hex);
          this.statusChip.style.removeProperty('--gf-swatch-img');
        }
      }

      if (this.statusMeta) {
        var sku = this.themeSkuEl ? this.themeSkuEl.textContent.trim() : '';
        this.statusMeta.textContent = [hex.toUpperCase(), sku]
          .filter(Boolean)
          .join(' · ');
      }

      if (this.statusAvail) {
        // Der uebersetzte Text steht schon am Swatch (visually-hidden), Ende
        // nach dem letzten Komma. So bleibt die Uebersetzung in den Locales.
        var a11y = selected.querySelector('.visually-hidden');
        var text = a11y ? a11y.textContent.trim() : '';
        var parts = text.split(',');
        this.statusAvail.textContent = parts.length
          ? parts[parts.length - 1].trim()
          : '';
        this.statusAvail.classList.toggle('is--soldout', !available);
      }
    }

    /** Alle Swatches, die aktuell nicht von Suche oder Filter ausgeblendet sind. */
    visibleSwatches() {
      return Array.prototype.filter.call(
        this.grid.querySelectorAll(SWATCH),
        function (el) {
          return !el.hasAttribute('hidden');
        }
      );
    }

    /** Spaltenzahl aus dem tatsaechlich berechneten Grid ablesen. */
    columnCount() {
      var tpl = window.getComputedStyle(this.grid).gridTemplateColumns;
      if (!tpl || tpl === 'none') return 1;
      return tpl.split(' ').filter(Boolean).length || 1;
    }

    handleKeydown(event) {
      var current = event.target.closest(SWATCH);
      if (!current || !this.grid.contains(current)) return;

      // Auswahl bestaetigen: an das Theme durchreichen, nicht selbst behandeln.
      if (event.key === ' ' || event.key === 'Enter') {
        event.preventDefault();
        current.click();
        return;
      }

      var items = this.visibleSwatches();
      var index = items.indexOf(current);
      if (index === -1) return;

      var columns = this.columnCount();
      var next = null;

      switch (event.key) {
        case 'ArrowRight':
          next = items[index + 1];
          break;
        case 'ArrowLeft':
          next = items[index - 1];
          break;
        case 'ArrowDown':
          next = items[index + columns];
          break;
        case 'ArrowUp':
          next = items[index - columns];
          break;
        case 'Home':
          next = items[0];
          break;
        case 'End':
          next = items[items.length - 1];
          break;
        default:
          return;
      }

      if (!next) return;
      event.preventDefault();
      this.moveFocusTo(next, items);
    }

    /**
     * Roving Tabindex: nur ein Swatch der Gruppe ist per Tab erreichbar.
     * Der Fokus bewegt sich, ohne die Variante zu wechseln — ausgewaehlt wird
     * erst mit Enter oder Leertaste.
     */
    moveFocusTo(target, items) {
      (items || this.visibleSwatches()).forEach(function (el) {
        el.setAttribute('tabindex', el === target ? '0' : '-1');
      });
      target.focus();
    }

    /** .is--selected (vom Theme gesetzt) nach aria-checked und tabindex spiegeln. */
    syncSelection() {
      var all = this.grid.querySelectorAll(SWATCH);
      var selected = this.grid.querySelector(SWATCH + '.is--selected');

      Array.prototype.forEach.call(all, function (el) {
        var isSelected = el === selected;
        el.setAttribute('aria-checked', isSelected ? 'true' : 'false');
        if (selected) el.setAttribute('tabindex', isSelected ? '0' : '-1');
      });

      // Ist die gewaehlte Farbe gerade weggefiltert, haette die Gruppe sonst
      // keinen Tab-Einstiegspunkt mehr.
      this.ensureTabStop();

      // Ein Frame warten: das Theme setzt die Swatch-Klasse und den SKU im
      // meta-Block in getrennten Schritten. Ohne das Warten wuerde der Status
      // gelegentlich noch den SKU der vorigen Variante spiegeln.
      window.requestAnimationFrame(this.updateStatus.bind(this));
    }

    /**
     * Bei sehr vielen Farben liegt die aktive weit unten. Beim Laden in den
     * sichtbaren Bereich holen — aber nur innerhalb des Rasters, damit die
     * Seite nicht wegspringt.
     */
    scrollSelectedIntoView() {
      var selected = this.grid.querySelector(SWATCH + '.is--selected');
      if (!selected) return;

      var gridBox = this.grid.getBoundingClientRect();
      var itemBox = selected.getBoundingClientRect();
      var overflows =
        itemBox.top < gridBox.top || itemBox.bottom > gridBox.bottom;
      if (!overflows) return;

      selected.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  }

  customElements.define('graffiti-color-picker', GraffitiColorPicker);
})();
